import { updateAppModule } from "../api/appModuleService";

export const useUpdateModule = (successCallback) => {
  const update = async (id, data) => {
    try {
        const updatedRecord = await updateAppModule(id, data);
        if (successCallback) successCallback();
        return updatedRecord;
    } catch (error) {
        console.error("Failed to update app module:", error);
        throw error;
    }
  };

  return { update };
};